<template>
    <div class="vx-card p-6" id="teacher-interaction">
        <div class="vx-row">
            <div class="vx-col w-full">
                <h4>{{ this.$t('dashboard.assignmentInformationAssessment') }}</h4>
            </div>
            <div class="vx-col w-full mt-4">
                <div class="vx-row">
                    <div class="vx-col md:w-1/3 w-full">
                        <label class="vs-input--label">{{ this.$t('timeKeeping.teacherMain') }}</label>
                        <span class="text-danger">*</span>
                        <v-select class="" v-model="teacherInteracInfo.teacherId" :clearable="false"
                                  v-validate="'required'"
                                  name="teacherMain" :options="teacherOptions" :reduce="option => option.value"
                                  @input="changeTeacher" :disabled="isUpdate || userInfo.userRole === 'user'">
                            <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                        </v-select>
                        <span class="text-danger text-sm">{{ errors.first('teacherMain') }}</span>
                    </div>
                    <div class="vx-col md:w-1/3 w-full" v-if="!isUpdate">
                        <label class="vs-input--label">{{ this.$t('timeKeeping.className') }}</label>
                        <v-select class="" v-model="selectedClass" :clearable="false" label="label"
                                  :options="classPermissionOptions" :reduce="option => option.value"
                                  @input="changeClassroom" v-validate="'required'" name="class">
                            <template #option="{ label, organizationBranchName }">
                                <h5 style="margin: 0">{{ label }}</h5>
                                <em>{{ organizationBranchName }}</em>
                            </template>
                            <template #selected-option="{ label, organizationBranchName }">
                                <div class="flex items-center gap-2">
                                    <strong>{{ label }}</strong>
                                    <em>{{ organizationBranchName }}</em>
                                </div>
                            </template>
                            <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                        </v-select>
                        <span class="text-danger text-sm">{{ errors.first('class') }}</span>
                    </div>
                    <div class="vx-col md:w-1/3 w-full">
                        <label class="vs-input--label">{{ this.$t('timeKeeping.type') }}</label>
                        <span class="text-danger">*</span>
                        <v-select class="" v-model="teacherInteracInfo.type" :clearable="false" v-validate="'required'"
                                  :options="typeOptions" :reduce="option => option.value" name="typeInterac"
                                  :disabled="isUpdate">
                            <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                        </v-select>
                        <span class="text-danger text-sm">{{ errors.first('typeInterac') }}</span>
                    </div>
                    <div class="vx-col w-full mt-4" v-if="!isUpdate">
                        <label class="vs-input--label">{{ this.$t('navMenu.student') }}</label>
                        <span class="text-danger">*</span>
                        <multiselect
                            name="student"
                            data-vv-validate-on="input"
                            v-model="selectedStudent"
                            :options="studentOptions"
                            group-values="libs"
                            group-label="all"
                            :group-select="true"
                            :show-labels="false"
                            :multiple="true"
                            :close-on-select="false"
                            placeholder=""
                            label="label"
                            track-by="value"
                            v-validate="'required'"
                        >
                            <template #noResult>
                                <span>{{ $t('menuOrganization.noDataMatching') }}</span>
                            </template>
                            <template #noOptions>
                                <span>{{ $t('menuOrganization.noData') }}</span>
                            </template>
                        </multiselect>
                        <span class="text-danger text-sm">{{ errors.first('student') }}</span>
                    </div>
                    <div class="vx-col md:w-1/3 w-full" v-else>
                        <label class="vs-input--label">{{ this.$t('navMenu.student') }}</label>
                        <span class="text-danger">*</span>
                        <vs-input class="w-full" v-model="teacherInteracInfo.studentName" disabled></vs-input>
                    </div>
                    <div class="vx-col w-full mt-4">
                        <label class="vs-input--label">{{ this.$t('news.content') }}</label>
                        <span class="text-danger">*</span>
                        <vs-textarea class="w-full" v-model="teacherInteracInfo.content" name="content"
                                     v-validate="'required'" :disabled="isUpdate"></vs-textarea>
                        <span class="text-danger text-sm">{{ errors.first('content') }}</span>
                    </div>
                    <div class="vx-col w-full mt-4 flex flex-wrap gap-2">
                        <div class="flex justify-center upload">
                            <div class="file-upload" @dragover="dragover" @dragleave="dragleave"
                                 @drop="drop">
                                <input ref="fileUpload" type="file" id="imageUpload" multiple
                                       class="hidden" @change="uploadFile()" :disabled="isUpdate">
                                <div class="">
                                    <div class="text-center">
                                        <feather-icon icon="UploadCloudIcon" svgClasses="h-10 w-10 text-primary"/>
                                    </div>
                                    <div class="text-center button-upload">
                                        <vs-button @click="$refs.fileUpload.click()">{{ this.$t('menuOrganization.selectedFile') }}</vs-button>
                                    </div>
                                    <div class="text-center mt-4">
                                        <label class="file-label text-primary">
                                            <div v-if="isDragging">{{ this.$t('menuOrganization.releaseToDropTheFileHere') }}</div>
                                            <div v-else>{{ this.$t('menuOrganization.dropFilesHere') }}</div>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table-files">
                            <vs-table stripe :pagination="files.length > 0" maxItems="4" :data="files"
                                      noDataText="Không có dữ liệu">
                                <template slot="thead">
                                    <!--                                <vs-th>-->
                                    <!--                                    STT-->
                                    <!--                                </vs-th>-->
                                    <vs-th>
                                        Name
                                    </vs-th>
                                    <vs-th v-if="!isUpdate">
                                        Actions
                                    </vs-th>
                                </template>

                                <template slot-scope="{data}">
                                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                        <!--                                    <vs-td>-->
                                        <!--                                        {{ indextr + 1 }}-->
                                        <!--                                    </vs-td>-->

                                        <vs-td class="text-primary">
                                            {{ tr.name }}
                                        </vs-td>

                                        <vs-td v-if="!isUpdate">
                                            <div class="flex items-center">
                                                <vx-tooltip class="position-icon" :text="$t('button.delete')"
                                                            position="top">
                                                    <feather-icon icon="TrashIcon" class="action-err icon-btn"
                                                                  svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                                                                  @click="deleteFile(indextr)"/>
                                                </vx-tooltip>
                                            </div>
                                        </vs-td>
                                    </vs-tr>
                                </template>
                            </vs-table>
                        </div>
                    </div>
                    <div class="vx-col w-full mt-6 flex justify-end" v-if="!isUpdate">
                        <vs-button class="ml-auto mt-2" @click="saveChanges" :disabled="!validateForm">{{
                                `${isUpdate ?
                                    $t('button.update') : $t('button.create')}`
                            }}
                        </vs-button>
                        <vs-button class="ml-4 mt-2" type="border" color="warning" @click="$router.go(-1)">
                            {{ $t('button.back') }}
                        </vs-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import vSelect from 'vue-select'
import Multiselect from 'vue-multiselect'

export default {
    name: "TeacherInteractionInfo",
    components: {
        vSelect,
        Multiselect
    },

    props: {
        detailsId: {}
    },

    data() {
        return {
            userInfo: JSON.parse(localStorage.getItem('userInfo')),
            teacherOptions: [],
            classPermissionOptions: [],
            selectedClass: null,
            studentOptions: [
                {
                    all: 'Tất cả',
                    libs: []
                }
            ],
            selectedStudent: null,
            typeOptions: [
                {value: 1, label: 'Bài tập'},
                {value: 2, label: 'Đánh giá'},
            ],
            selectedType: null,
            isUpdate: false,
            content: null,
            files: [],
            isDragging: false,
            teacherInteracInfo: {
                content: null,
                type: null,
                teacherId: null,
            },
        }
    },

    async created() {
        if (this.userInfo.userRole === 'organization') {
            await this.getDataTeacher()
        } else {
            this.teacherOptions = [{value: this.userInfo.employeeId, label: this.userInfo.fullName}]
            this.teacherInteracInfo.teacherId = this.userInfo.employeeId
            await this.getClassPermission()
        }
        if (this.detailsId) this.getDetails()
    },

    computed: {
        validateForm() {
            return !this.errors.any()
        },
    },

    methods: {
        getDataTeacher() {
            return new Promise((resolve, reject) => {
                let payload = {
                    departmentType: 1,
                    enabled: true
                }

                this.$vs.loading()
                this.$crm.post('/employee/all', payload).then(res => {
                    if (res.data && res.data.length > 0) {
                        this.teacherOptions = res.data.map(el => {
                            return {
                                value: el.employeeId,
                                label: el.fullName
                            }
                        })
                    } else {
                        this.teacherOptions = []
                    }
                    resolve(res)
                    this.$vs.loading.close()
                }).catch(err => {
                    reject(err)
                    this.$vs.loading.close()
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                })
            })
        },

        getClassPermission() {
            return new Promise((resolve, reject) => {
                this.$vs.loading()
                this.$crm.post(`/employee/find-by-id/${this.teacherInteracInfo.teacherId}`).then(res => {
                    if (res.data.managedClassRooms.length > 0) {
                        let branchList = JSON.parse(localStorage.getItem('branchInfoList'))
                        this.classPermissionOptions = res.data.managedClassRooms.map(el => {
                            let branch = branchList.find(x => x.id === el.organizationBranchId)
                            if (branch) el.organizationBranchName = branch.organizationBranchName
                            return {
                                value: el.id,
                                label: el.className,
                                organizationBranchName: el.organizationBranchName ? el.organizationBranchName : null
                            }
                        })
                    } else {
                        this.classPermissionOptions = []
                    }
                    resolve(res)
                    this.$vs.loading.close()
                }).catch(err => {
                    reject(err)
                    this.$vs.loading.close()
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                })
            })
        },

        getStudentData() {
            return new Promise((resolve, reject) => {
                let payload = {
                    classId: this.selectedClass,
                    enabled: true,
                    pageNumber: 1,
                    pageSize: 1000
                }

                this.$vs.loading()
                this.$crm.post('/school-student/search', payload).then(res => {
                    if (res.data.content && res.data.content.length > 0) {
                        this.studentOptions = [
                            {
                                all: 'Tất cả',
                                libs: []
                            }
                        ]
                        this.studentOptions[0].libs = res.data.content.map(el => {
                            return {
                                value: el.id,
                                label: el.fullName
                            }
                        })
                    } else {
                        this.studentOptions = []
                    }
                    resolve(res)
                    this.$vs.loading.close()
                }).catch(err => {
                    reject(err)
                    this.$vs.loading.close()
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                })
            })
        },

        async changeTeacher() {
            this.selectedClass = null
            this.selectedStudent = null
            this.classPermissionOptions = []
            this.studentOptions = []
            if (this.teacherInteracInfo.teacherId) {
                await this.getClassPermission()
            }
        },

        async changeClassroom() {
            this.selectedStudent = null
            this.studentOptions = []
            if (this.selectedClass) {
                await this.getStudentData()
            }
        },

        async saveChanges(evt) {
            evt.preventDefault();
            if (!this.validateForm) return;
            const result = await this.$validator.validateAll();
            if (!result) return;

            let formData = new FormData(), config = {};
            config = {
                headers: {
                    "Content-Type": "multipart/form-data"
                },
            };

            this.teacherInteracInfo.studentIds = this.selectedStudent.map(el => el.value)

            const blob = new Blob([JSON.stringify(this.teacherInteracInfo)], {type: 'application/json'});
            formData.append('dto', blob);
            this.files.forEach(el => formData.append('files', el))

            this.$vs.loading()
            this.$crm.post('/teacher-interaction/create', formData, config).then(() => {
                this.$vs.loading.close()
                this.$vs.notify({
                    text: 'Tạo mới thành công!',
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                })
                this.$router.go(-1)
            }).catch(err => {
                this.$vs.loading.close()
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
        },

        dragover(e) {
            e.preventDefault()
            this.isDragging = true
        },
        dragleave() {
            this.isDragging = false
        },
        drop(e) {
            e.preventDefault()
            if (!this.isUpdate) {
                this.$refs.fileUpload.files = e.dataTransfer.files
                this.uploadFile()
                this.isDragging = false
            }
        },

        uploadFile() {
            let file = this.$refs.fileUpload.files
            // if (file.size > 200000000) {
            //     return this.$vs.notify({
            //         title: 'Lỗi',
            //         text: 'Kích thước tệp không được vượt quá 200MB',
            //         iconPack: 'feather',
            //         icon: 'icon-alert-circle',
            //         color: 'warning'
            //     })
            // }
            this.files.push(...file);
            this.$refs.fileUpload.value = null
        },

        deleteFile(ind) {
            this.files.splice(ind, 1)
        },

        getDetails() {
            this.$vs.loading()
            this.$crm.get(`/teacher-interaction/find-by-id/${this.detailsId}`).then(res => {
                this.isUpdate = true
                this.teacherInteracInfo = res.data
                this.teacherInteracInfo.studentName = this.teacherInteracInfo.student.fullName
                this.teacherInteracInfo.teacherId = this.teacherInteracInfo.teacher.id
                this.files = this.teacherInteracInfo.fileManagers
                this.$vs.loading.close()
            }).catch(err => {
                this.$vs.loading.close()
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
        },
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
#teacher-interaction {
    .multiselect__tags {
        max-height: 100px !important;

        .multiselect__tags-wrap {
            max-height: 90px !important;
            overflow-y: auto;
            display: block;
        }
    }

    .upload {
        .file-upload {
            width: 200px;
            height: 200px;
            border: dashed 2px rgba(var(--vs-primary), 1);
            border-radius: 0.8rem;
            display: flex;
            align-items: center;
            justify-content: center;

            .button-upload button {
                border-radius: 1.5rem;
            }

            .file-label {
                color: #C0C0C0;
            }
        }
    }

    .table-files {
        width: calc(100% - 210px);

        .vs-table--tbody,
        .vs-table--thead {
            position: static;
        }

        .vs-pagination--buttons {
            z-index: 0;
        }
    }

    .multiselect__content-wrapper {
        z-index: 500!important;
        box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 1px, rgba(0, 0, 0, 0.07) 0px 2px 2px, rgba(0, 0, 0, 0.07) 0px 4px 4px, rgba(0, 0, 0, 0.07) 0px 8px 8px, rgba(0, 0, 0, 0.07) 0px 16px 16px;
    }
}
</style>
